import React  from 'react';
import {Link} from 'react-router-dom';

const imageNames = {
    golang: require('../assets/img/golang3.gif'),
    k8s: require('../assets/img/k8s.gif'),
    dockerlogo:require('../assets/img/dockerlogo.jpg'),
    strumia:require('../assets/img/physics/strumia/strumia.jpg'),
    flag:require('../assets/img/flag.jpg'),
    gauss:require('../assets/img/physics/gauss/gauss.jpg'),
    dirac:require('../assets/img/physics/bits/dirac.jpg'),
    boole2:require('../assets/img/physics/bits/George_Boole2.jpg'),
    foleybook:require('../assets/img/physics/foleyrot/cpgraphics.gif'),
    angular:require('../assets/img/angular.png'),
    orion:require('../assets/img/physics/orion/orionboon4.jpg'),
    magrealitybw:require('../assets/img/magreal/magrealbw.gif'),
    casimir:require('../assets/img/physics/casimir/casimir2.gif'),
    mossbauer:require('../assets/img/physics/mossbauer/mossbauer_opt2.jpg')
 };

const ArticleGeneric =(props) => {
        return (<article className="blog-teaser">
                <header>
                  <img src={imageNames[props.ImageName]} alt=""/>
                   {props.Link}
                  <h3><Link to={props.ReadMoreTo}>{props.ReadMoreToText}</Link></h3> 
                 <hr/>                         
                </header>
                  <div className="body">
                    {props.Body}
                  </div>
                  <div className="clearfix">
                    <Link  className="btn btn-tales-one" to={props.ReadMoreTo}>Read more</Link>
                  </div>
                </article> );
    }

 
export default ArticleGeneric;